export default __webpack_public_path__ + "static/media/primary_illustration.6218e684.png";